import { Size } from '@ps/web-core-enums';
import { Translation, useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useCallback, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { PrizePlayerProviderContext } from '../../../../providers/PrizePlayerProvider';

import {
  TXTCLI_N0N_of_games,
  TXTCLI_Players_42,
  TXTCLI_Select_the_number_of_players_t_ELL
} from './PlayersToggle.messages.json';
import styles from './PlayersToggle.scss';

export interface PlayersToggleProps {
  weights: number[];
  numPlayersList: number[];
}

const PlayersToggle: React.FC<PlayersToggleProps> = ({ weights, numPlayersList }) => {
  const { greaterThan } = useScreenSize();
  const isMobile = useSelector(select.device.isMobile);
  const smallScreen = !greaterThan(Size.Small);
  const isSmallScreen = isMobile || smallScreen;
  const { selectedPlayerIndex, setSelectedPlayerIndex, numberOfPlayers, setNumberOfPlayers } =
    useContext(PrizePlayerProviderContext);
  const weight = weights[selectedPlayerIndex];

  const handleNumberOfPlayer = useCallback(
    (player: number | undefined) => {
      if (player !== undefined) {
        setNumberOfPlayers(player);
        setSelectedPlayerIndex(numPlayersList.indexOf(player));
      }
    },
    [numPlayersList, setNumberOfPlayers, setSelectedPlayerIndex]
  );

  const playersList = useMemo(
    () =>
      numPlayersList.map((player) => (
        <button
          key={`max-toggle-${player}`}
          type="button"
          className={classNames(styles.button, { [styles.active]: numberOfPlayers === player })}
          onClick={() => handleNumberOfPlayer(player)}
        >
          {player}
        </button>
      )),
    [handleNumberOfPlayer, numPlayersList, numberOfPlayers]
  );

  return (
    <div
      className={classNames(styles.playersMax, {
        [styles.mobileContainer]: isSmallScreen
      })}
    >
      <div className={classNames(styles.playersMaxItem, styles.description)}>
        <Translation {...TXTCLI_Select_the_number_of_players_t_ELL} />
      </div>
      <div className={classNames(styles.playersMaxItem, styles.label)}>
        <Translation {...TXTCLI_Players_42} />
      </div>
      <div className={classNames(styles.playersMaxItem, styles.value)}>{numberOfPlayers}</div>
      {!!weight && (
        <div className={classNames(styles.playersMaxItem, 'meta')}>
          (<Translation {...TXTCLI_N0N_of_games} values={{ 0: `${weight}` }} />)
        </div>
      )}
      <nav
        className={classNames(styles.nav, {
          [styles.mobileNavContainer]: isSmallScreen
        })}
      >
        {playersList}
      </nav>
    </div>
  );
};

export default PlayersToggle;
